var _style, _path, _path2, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-sort_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-sort_svg__st0{fill:#050505}.icon-sort_svg__st1{opacity:.5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-sort_svg__st0",
    d: "M14.4 21.5c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l3.3 3.3 3.3-3.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4 4c-.2.2-.5.3-.7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-sort_svg__st0",
    d: "M14.4 16.6c-.6 0-1-.4-1-1V3.5c0-.6.4-1 1-1s1 .4 1 1v12.1c0 .5-.5 1-1 1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-sort_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-sort_svg__st0",
    d: "M11 7.5H5.6c-.6 0-1-.4-1-1s.4-1 1-1H11c.6 0 1 .4 1 1s-.4 1-1 1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "icon-sort_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-sort_svg__st0",
    d: "M11 12.3H5.6c-.6 0-1-.4-1-1s.4-1 1-1H11c.6 0 1 .4 1 1s-.4 1-1 1z"
  }))));
}

export default SvgIconSort;